const API_PATHNAME = /** @type {const} */ ({
  GET_TEST_STATUS: '/api/front/dev/getTestStatus',
  LAUNCH_TESTS: '/api/front/dev/launchTests',
  GET_RELOAD_COUNT: '/api/front/getReloadCount',
  IOS_START: '/api/front/iosStart',
  REDIRECT_AFTER_FACEBOOK_SHARE: '/api/front/redirectAfterFacebookShare',
  SAVE_TOKEN: '/api/front/saveToken',
  SHARE_ON_WHATSAPP: '/api/front/shareOnWhatsapp',
})

module.exports = { API_PATHNAME }
